module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "flutterTesting.681fa9ee.png";